<template>
    <div v-show="show" id="marketing-banner" tabindex="-1" class="fixed z-50 flex flex-col md:flex-row justify-between w-[calc(100%-2rem)] p-4 -translate-x-1/2 bg-white border border-gray-100 rounded-lg shadow-sm lg:max-w-7xl left-1/2 md:top-20 dark:bg-gray-700 dark:border-gray-600">
        <div class="flex flex-col items-start mb-3 me-4 md:items-center md:flex-row md:mb-0">
            <a href="#" class="flex items-center mb-2 border-gray-200 md:pe-4 md:me-4 md:border-e md:mb-0 dark:border-gray-600">
                <img src="~assets/img/warning.svg" class="h-6 me-2" alt="Caution">
                <span class="self-center text-lg font-semibold whitespace-nowrap dark:text-white">不可替代紧急医疗服务</span>
            </a>
            <p class="flex items-center text-sm font-normal text-gray-500 dark:text-gray-400">北美好医生不能替代紧急医疗服务，紧急情况，直接联系您的医生或拨打911</p>
        </div>
        <div class="flex items-center flex-shrink-0">
            <a @click="show=false" class="px-5 py-2 me-2 text-xs font-medium text-white bg-primary-700 rounded-lg hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800">我知道了</a>
            <button @click="show=false" data-dismiss-target="#marketing-banner" type="button" class="flex-shrink-0 inline-flex justify-center w-7 h-7 items-center text-gray-400 hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 dark:hover:bg-gray-600 dark:hover:text-white">
                <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                </svg>
                <span class="sr-only">Close banner</span>
            </button>
        </div>
    </div>
</template>
<script setup>
    const show = ref(true)
    import { useToast } from 'vue-toastification'
    const toast = useToast()

    onMounted(async () => {
        toast.error('北美好医生不能替代紧急医疗服务，如您有紧急情况，直接联系医生或拨打911',{
            position: 'bottom-center',
            timeout: 15000,
        })
 
    
    })

</script>